import { USER_TITLE_OTHER } from '../../global/models/models.user';
export const getName = (user) => {
    return [
        [USER_TITLE_OTHER, '--'].includes(user.title) ? '' : user.title,
        user.firstName,
        user.lastName,
    ]
        .filter(Boolean)
        .join(' ');
};
